import React, { useContext, useEffect, useState } from "react";
import Toggle from "../../../components/Atomos/Checkbox/Toggle";
import AuthContext from "../../../store/AuthContext";
import { patchUserPreferences } from "../../../Services/UserPreferences";
import { setCookie } from "../../../utils/cookies";
import EventBus, { EventBusValues } from "../../../utils/EventBus";
import { toastPromise } from "../../../utils/toast";

export default function TwoFactorAuth(): React.ReactElement {
  const [twoAuthEnabled, setTwoAuthEnabled] = useState<boolean>(false);
  const { loggedPerson, set2FAuth } = useContext(AuthContext);

  useEffect(function setInitialState() {
    if (loggedPerson) {
      setTwoAuthEnabled(
        loggedPerson?.twoFactorAuthentication?.status ?? false
      );
    }
  }, [loggedPerson]);

  function handleToggleTwoAuth(): void {
    const newValue = !twoAuthEnabled;
    setTwoAuthEnabled(newValue);
    handleConfirmTwoAuth(newValue);
  }

  async function handleConfirmTwoAuth(newValue?: boolean): Promise<void> {
    try {
      if (!loggedPerson) {
        throw new Error("User information not found");
      }

      const valueToSet = newValue !== undefined ? newValue : twoAuthEnabled;

      const twoFactorAuthentication = {
        status: valueToSet,
        updatedAt: new Date().toISOString(),
      };

      const promise = patchUserPreferences({ twoFactorAuthentication });
      await toastPromise(promise);

      const updatedPerson = {
        ...loggedPerson,
        twoFactorAuthentication,
      };

      if (valueToSet) {
        setCookie("2FAuth", "true", 0);
        set2FAuth(true);
      } else {
        setCookie("2FAuth", "false", 0);
        set2FAuth(false);
      }

      EventBus.dispatch(EventBusValues.UpdateLoggedPerson, updatedPerson);
    } catch (error) {
      console.error("Error updating 2FA setting:", error);
      setTwoAuthEnabled(!twoAuthEnabled);      
    }
  }

  return (
    <>
      <div className="w-full h-full lg:py-6 lg:pl-12 lg:pr-6  flex flex-col gap-y-4 lg:gap-y-8">
        <h4 className="font-decimal text-primary font-[600] text-sm lg:text-xl text-left">
            Recommended
        </h4>
        <div className="flex flex-row justify-start">
          <span className="roboto-font lg:text-lg text-gray-font text-left">
            Activate Two-Factor Authentication. This improves account security
            and protects the WSG Community.
          </span>
        </div>
        <div className="flex flex-row gap-x-6 items-center justify-between lg:justify-start">
          <h4 className="font-roboto-font text-[#484F56] font-bold text-sm sm:text-base lg:text-lg text-left">
            Two-Factor Authentication
          </h4>
          <Toggle
            toggleEnabled={twoAuthEnabled}
            handleToggle={handleToggleTwoAuth}
          />
        </div>
      </div>
    </>
  );
}
